import { render, staticRenderFns } from "./reasonSelectBox.vue?vue&type=template&id=6f478ca5&scoped=true"
import script from "./reasonSelectBox.vue?vue&type=script&lang=js"
export * from "./reasonSelectBox.vue?vue&type=script&lang=js"
import style0 from "./reasonSelectBox.vue?vue&type=style&index=0&id=6f478ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f478ca5",
  null
  
)

export default component.exports